export class SchemaRegistryAuthConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SchemaRegistryAuthType",
            "format": ""
        },
        {
            "name": "credentialsSecret",
            "baseName": "credentialsSecret",
            "type": "SecretRef",
            "format": ""
        },
        {
            "name": "tlsSecret",
            "baseName": "tlsSecret",
            "type": "SecretRef",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryAuthConfig.attributeTypeMap;
    }
    constructor() {
    }
}
